import React from "react";
import { Box, Skeleton } from '@mui/material';

const FormMovimiento = () => {
  return (
    <Box>
      <Skeleton
        animation="wave"
        height={10}
        width="40%"
        style={{ marginBottom: 6 }}
      />
      <Skeleton sx={{ height: 40, marginBottom: 1 }} animation="wave" variant="rectangular" />
      <Skeleton sx={{ height: 40, marginBottom: 1 }} animation="wave" variant="rectangular" />
      <Skeleton
        animation="wave"
        height={30}
        width="40%"
        style={{ marginBottom: 6 }}
      />
    </Box>
  )
}

export default FormMovimiento;